import React from 'react';
const facts = [{
  value: '40',
  label: 'Weeks of classes, in order'
}, {
  value: '300',
  label: 'Pages of counted combos'
}, {
  value: '3',
  label: 'Levels in every combo'
}, {
  value: '21',
  label: 'Planning worksheets'
}];
export function SocialProofBar() {
  return <section className="w-full bg-plum-deep" data-id="element-275" data-mp="25suajgoklzlz">
      <div className="max-w-6xl mx-auto px-5 pb-14 sm:pb-16" data-id="element-276" data-mp="25u5at6it4p8c">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-plum-line bg-plum-line sm:grid-cols-4" data-id="element-277" data-mp="32iutgz29dlvd">
          {facts.map(fact => <div key={fact.label} className="bg-plum px-4 py-5 text-center" data-id="element-278" data-mp="2xhxbonl5utue">
              <div className="font-display font-bold text-3xl sm:text-4xl leading-none text-gold" data-id="element-279" data-mp="2tgvai17oo7ps">
                {fact.value}
              </div>
              <div className="mt-2 text-[10px] font-semibold uppercase tracking-widest text-white/60" data-id="element-280" data-mp="1i2zxoz494b1q">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}